import { render } from "./ScopeModalCreate.vue?vue&type=template&id=79c1a5e8"
import script from "./ScopeModalCreate.vue?vue&type=script&lang=js"
export * from "./ScopeModalCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__